import React, { useEffect, useState } from "react";
import * as func from "../../common/athleteCommon/FunctionCalls";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";

const WLRecord = () => {

    const [worldRecordData, setWorldRecordData] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchWorldRecord() {
            setIsLoading(true);
            const worldRecordResponse = await func.worldRecord(null);
            setWorldRecordData(Array.isArray(worldRecordResponse) ? worldRecordResponse : [])
            setIsLoading(false);
        }
        fetchWorldRecord();
    }, []);

    const filteredData = worldRecordData.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const weightClassRender = (rowData) => {
        return <span>{rowData.weightClass}</span>;
    };

    const recordCategoryRender = (rowData) => {
        return <span>{rowData.recordCategory}</span>;
    };

    const recordValueRender = (rowData) => {
        return <span>{rowData.recordValue}</span>;
    };

    const recordUnitRender = (rowData) => {
        return <span>{rowData.recordUnit}</span>;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const athleteDobRender = (rowData) => {
        return <span>{formatDate(rowData.athleteBorn)}</span>;
    };

    const athleteNationRender = (rowData) => {
        return <span>{rowData.athleteNation}</span>;
    };

    const eventDateRender = (rowData) => {
        return <span>{formatDate(rowData.eventDate)}</span>;
    };

    const eventPlaceRender = (rowData) => {
        return <span>{rowData.eventPlace}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };
    
    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="weightClass"
                                                header="Weight Class"
                                                body={weightClassRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="recordCategory"
                                                header="Record Category"
                                                body={recordCategoryRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="recordValue"
                                                header="Record Value"
                                                body={recordValueRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="recordUnit"
                                                header="Record Unit"
                                                body={recordUnitRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteBorn"
                                                header="Date of Birth"
                                                body={athleteDobRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteNation"
                                                header="Nation"
                                                body={athleteNationRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="eventDate"
                                                header="Event Date"
                                                body={eventDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="eventPlace"
                                                header="Event Place"
                                                body={eventPlaceRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default WLRecord;